import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store';

import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import BugsnagPerformance from '@bugsnag/browser-performance'

import App from './App';

Bugsnag.start({
  apiKey: 'cc74ebad0f7541d9868a625eec57959f',
  plugins: [new BugsnagPluginReact()]
})
BugsnagPerformance.start({ apiKey: 'cc74ebad0f7541d9868a625eec57959f' })

const reactPlugin = Bugsnag.getPlugin('react');
if (!reactPlugin) {
  throw new Error("Bugsnag React plugin not found");
}
const ErrorBoundary = reactPlugin.createErrorBoundary(React);


ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
      <ErrorBoundary>
       <App />
       </ErrorBoundary>
    </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);